import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 40px auto 20px auto;
`;
